import React from "react";
import { FaBell, FaCalendarCheck, FaCar, FaClock, FaCog, FaCreditCard, FaIdCard, FaTruck, FaUserFriends, FaUserPlus } from "react-icons/fa";

const ICONS = {
    account: FaUserPlus, kyc: FaIdCard, booking: FaCalendarCheck, payment: FaCreditCard, reminder: FaClock,
    trip: FaCar, handover: FaTruck, staff: FaUserFriends, system: FaCog,
};

export const timeAgo = (value) => {
    const time = new Date(value).getTime();
    if (!Number.isFinite(time)) return "";
    const seconds = Math.max(0, Math.round((Date.now() - time) / 1000));
    if (seconds < 60) return "Just now";
    if (seconds < 3600) return `${Math.floor(seconds / 60)} min ago`;
    if (seconds < 86400) return `${Math.floor(seconds / 3600)} h ago`;
    if (seconds < 7 * 86400) return `${Math.floor(seconds / 86400)} d ago`;
    return new Date(time).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
};

const NotificationItem = ({ item, onOpen }) => {
    const Icon = ICONS[item.category] || FaBell;
    const unread = !item.readAt;
    return (
        <button type="button" className={`notif-item${unread ? " is-unread" : ""}${item.priority === "high" ? " is-high" : ""}`} onClick={() => onOpen(item)}>
            <span className="notif-item-icon" aria-hidden="true"><Icon /></span>
            <span className="notif-item-text">
                <span className="notif-item-title">{item.title}</span>
                {item.body ? <span className="notif-item-body">{item.body}</span> : null}
                {/* A picture sent with the message (Notification Centre R4) */}
                {item.image && String(item.image).startsWith("https://") ? <img src={item.image} alt="" loading="lazy" style={{ display: "block", width: "100%", maxWidth: 320, aspectRatio: "2 / 1", objectFit: "cover", borderRadius: 8, marginTop: 6 }} /> : null}
                <span className="notif-item-time">{timeAgo(item.createdAt)}</span>
            </span>
            {unread ? <span className="notif-item-dot" aria-label="Unread" /> : null}
        </button>
    );
};

export default NotificationItem;
